import React, { Component } from "react";
import { FiDownload } from "react-icons/fi";


class Breadcrumb extends Component{
    render(){
        const { title , parent} = this.props;
        return(
            <React.Fragment>
                <div className="breadcrumb-area rn-bg-color ptb--120 bg_image bg_image--1" >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="breadcrumb-inner pt--100">
                                    <h2 className="title">My Portfolio</h2>
                                    <h4>Some of my works that I love to share. For a deeper look into my professional experience and projects, download my technical portfolio for detailed case studies and engineering contributions</h4>
                                    <a href="/assets/file/Bryan Kenneth - Technical Portfolio.pdf" target="_blank" className="rn-btn"><FiDownload /> Technical Portfolio</a>
                                    {/* <ul className="page-list">
                                        <li className="breadcrumb-item"><Link to={`${process.env.PUBLIC_URL}`}>Home</Link></li>
                                        {parent? <li className="breadcrumb-item">{parent}</li>:''}
                                        <li className="breadcrumb-item active">{title}</li>
                                    </ul> */}
                                </div>
                                
                            </div>

                            {/* <div className="col-lg-6">
                                <BrandTwo />
                            </div> */}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Breadcrumb;

